import {
  Directive,
  Input,
  ElementRef,
  OnChanges
} from '@angular/core';

@Directive({
  selector: '[textToCanvas]'
})

export class TextToCanvas implements OnChanges {
  canvas: any;
  context: any;
  lastWidth: number;
  lastHeight: number;

  @Input() inputs: any = {};

  constructor(
    private _eref: ElementRef
  ) {
    this.canvas = this._eref.nativeElement;
    this.context = this.canvas.getContext('2d');
  }

  getHeight(text, x, y, maxWidth, lineHeight) {
    let canvas = document.createElement('canvas')
      , context = canvas.getContext('2d');

    let words = text.split(' ')
      , line = ''
      , testLine, metrics, testWidth;

    for (let n = 0; n < words.length; n++) {
      testLine = line + words[n] + ' ';
      metrics = context.measureText(testLine);
      testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        context.fillText(line, x, y);
        line = words[n] + ' ';
        y += lineHeight;
      } else {
        line = testLine;
      }
    }

    return y + (lineHeight * 3);
  }

  wrapText(context, text, x, y, maxWidth, lineHeight) {
    let words = text.split(' ')
      , line = '';
    let testLine, metrics, testWidth;

    for (let n = 0; n < words.length; n++) {
      testLine = line + words[n] + ' ';
      metrics = context.measureText(testLine);
      testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        context.fillText(line, x, y);
        line = words[n] + ' ';
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    context.fillText(line, x, y);
  }

  ngOnChanges() {
    let context, text, maxWidth, lineHeight;

    if (this.lastWidth && this.lastHeight) {
      this.context.clearRect(0, 0, this.lastWidth, this.lastHeight);
    }

    context = this.context;

    if (this.inputs && this.inputs.text) {
      maxWidth = 880;
      lineHeight = 24;
      text = this.inputs.text;

      this.canvas.width = this.lastWidth = 960;
      this.canvas.height = this.lastHeight = this
        .getHeight(text, (this.canvas.width - maxWidth) / 2, 12, maxWidth, lineHeight);

      context.font = '15px "Lato",Helvetica,Arial,sans-serif';
      context.fillStyle = '#000000';

      this.wrapText(context, text, (this.canvas.width - maxWidth) / 2, 12, maxWidth, lineHeight);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/text-to-canvas/text-to-canvas.directive.ts